
// tslint:disable-next-line:variable-name
export const TIME_PARTICLE_lIST = [
  {
    key: 'second',
    value: '秒',
  },
  {
    key: 'minute',
    value: '分',
  },
  {
    key: 'hour',
    value: '时',
  },
  {
    key: 'day',
    value: '日',
  },
  {
    key: 'month',
    value: '月',
  },
  {
    key: 'year',
    value: '年',
  }
];

export const RELATIVE_TYPE = [
  {
    key: -1,
    value: '之前'
  },
  {
    key: 1,
    value: '之后'
  }
];
